<div class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300">
    <h2 class="text-sm mb-0">{{'AUTOMATION.CREATE.FILTER_CONDITIONS' | translate }}</h2>
    <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup()"></i>
  </div>
  <!-- Header -->

  <!-- Message -->
  <div>
  <p-message severity="error" icon="fa fa-info-circle" data-testid="query-builder-message" aria-label="query-builder-message">
      {{'AUTOMATION.CREATE.QUERY_BULIDER_NOTE' | translate }}
  </p-message>  
</div>  
  <!-- Message -->


  <!-- Content -->
  <div class="surface-50 text-sm p-3">
    <div class="mb-8 pb-8">
        <query-builder [tenantId]="modelData.tenantId"
        [eventType]="eventType"
        (rule)="getRule($event)"
        [query]="modelData.sqlQuery"
        [savedJsonRule]="modelData.jsonRule"
     />
  </div>


  </div>
  <!-- Content -->

  <!-- Footer -->
  <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
    <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-text text-sm" (click)="closePopup()" />
    <p-button [label]="'AUTOMATION.CREATE.BTN_FILTER_COND'| translate " styleClass="text-sm" (click)="useRule()" />
  </div>
  <!-- Footer -->